import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=885de126&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=885de126&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885de126",
  null
  
)

component.options.__file = "Switch.vue"
export default component.exports